
export default function windowLoad(callback) {
  window.addEventListener('load', callback);
};
